<template>
  <div
    class="button-group flex flex-row justify-center mx-auto pointer-events-none"
  >
    <div
      class="relative h-full flex flex-row flex-row justify-center text-chplus-s button-row"
    >
      <slot>
        <button>Button 1</button>
        <button>Button 2</button>
        <button>Button 3</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonGroup"
};
</script>

<style scoped>
.button-group {
  height: 1.6rem;
  vertical-align: middle;
  width: 100%;
}
/deep/ button {
  line-height: 1em;
  white-space: nowrap;
  pointer-events: all;
}

/* button widths */
/deep/ .button-large {
  width: 6rem;
  flex: 1 1 6rem;
}
/deep/ .button-search {
  width: 1.71875rem;
  flex: 1 1 1.71875rem;
  font-size: 1.1875rem;
}
/deep/ .button-heart {
  width: 2.625rem;
  flex: 1 1 2.625rem;
  font-size: 0.75rem;
}

/* button styles */
/deep/ .button-large.active {
  font-weight: bold;
}
/deep/ .button-large,
/deep/ .button-heart {
  border-width: 0.125rem;
  height: 100%;
  border-radius: 0.25rem;
  margin: 0 0.05rem;
}
/* dark theme */
/deep/ .button-large:not(.light-theme),
/deep/ .button-heart:not(.light-theme) {
  border-color: var(--interaction-light);
  color: var(--interaction-dark);
}
/* white theme */
/deep/ .button-large.light-theme,
/deep/ .button-heart.light-theme {
  border-color: white;
  color: white;
}
/* dark theme active */
/deep/ .button-large:not(.light-theme).active,
/deep/ .button-heart:not(.light-theme).active {
  background-color: var(--interaction-light);
  color: var(--color-regular);
}
/* white theme active */
/deep/ .button-large.light-theme.active,
/deep/ .button-heart.light-theme.active {
  background-color: white;
  color: var(--color-regular);
}
@media (min-width: 768px), (max-width: 380px), (max-height: 600px) {
  .button-group {
    height: 1.84375rem;
  }
  /deep/ button {
    line-height: calc(1.84375rem - 4px);
  }
  /deep/ .button-large {
    width: 7.2rem;
    flex: 0 0 7.2rem;
  }
  /deep/ .button-small,
  .button-search {
    width: 2rem;
    flex: 0 0 2rem;
    font-size: 1.375rem;
  }
  /deep/ .button-heart {
    width: 3.0625rem;
    flex: 0 0 3.0625rem;
    font-size: 0.9375rem;
  }
}
@media (max-width: 380px), (max-height: 600px) {
  /deep/ .button-large {
    width: 6.8rem;
    flex: 0 1 6.8rem;
  }
  /deep/ .button-large.text-chplus-s {
    font-size: 0.95rem;
  }
}
@media (min-width: 1024px) {
  /deep/ .button-large,
  /deep/ .button-heart {
    border-width: 2px;
  }

  .button-group {
    height: 2.5rem;
  }

  /deep/ .button-large,
  .filter-button {
    width: 8rem;
    flex: 0 1 8rem;
    font-size: 1.15rem;
  }

  /deep/ .button-search {
    width: 3rem;
    flex: 0 0 3rem;
    font-size: 1.5rem;
  }

  .button-row {
    gap: 0.25rem;
  }
}
</style>
